import createBehavior from '@js/functions/createBehavior.js';

import { useMotionReduce } from '../functions/motion'

const videoPlayPauseBehavior = createBehavior(
    'video-play-pause',
    {
        toggleVideoPlayBack() {
            if (!this.userPaused && this.intersecting && this.$video.paused) {
                this.$video.play()
                this.$playIcon.classList.remove('hidden')
                this.$pauseIcon.classList.add('hidden')
                if (this.$toggle) {
                    this.$toggle.setAttribute(
                        'aria-label',
                        this.$toggle.dataset.labelPlaying
                    )
                }
            } else {
                this.$video.pause()
                this.$playIcon.classList.add('hidden')
                this.$pauseIcon.classList.remove('hidden')
                if (this.$toggle) {
                    this.$toggle.setAttribute(
                        'aria-label',
                        this.$toggle.dataset.labelPaused
                    )
                }
            }
        },
        toggleVideoState(event) {
            event.preventDefault()
            event.stopPropagation()

            this.userPaused = !this.userPaused
            this.toggleVideoPlayBack()
        },
        motionStateChange(active) {
            this.userPaused = active
            this.toggleVideoPlayBack()
        },
        intersectionIn() {
            clearTimeout(this.intersectionTestTimer)
            this.intersecting = true
            this.$video.play().catch((error) => {
                if (error.name !== 'AbortError') {
                    console.error('Video play error:', error)
                }
            })
        },
        intersectionOut() {
            clearTimeout(this.intersectionTestTimer)
            this.intersecting = false
            this.$video.pause()
        },
        intersection(entries) {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.intersectionIn();
            } else {
              this.intersectionOut();
            }
          });
        }
    },
    {
        init() {
            this.$video = this.getChild('video')
            this.$toggle = this.getChild('toggle')
            this.$playIcon = this.getChild('iconpause')
            this.$pauseIcon = this.getChild('iconplay')

            if (!this.$video || (!this.$video.src && !this.$video.dataset.src)) {
                return
            }

            const [motionInitState, motionReduceDestroy] = useMotionReduce(
                this.motionStateChange
            )
            this.motionReduceDestroy = motionReduceDestroy

            this.userPaused = motionInitState
            this.intersecting = false
            this.intersectionTestTimer

            // Create new observer.
            this.observer = new IntersectionObserver(this.intersection, {
              rootMargin: '0px 0px 0px 0px'
            });
            this.observer.observe(this.node);

            if (!this.$video.src) {
                this.$video.src = this.$video.dataset.src
            }
            this.$video.load()

            if (this.$toggle) {
                this.$toggle.addEventListener(
                    'click',
                    this.toggleVideoState,
                    false
                )
            }

            if (
                !this.userPaused &&
                this.$video.getBoundingClientRect().top < window.innerHeight
            ) {
                this.$video.play()
                this.intersectionTestTimer = setTimeout(() => {
                    if (!this.intersecting) {
                        this.$video.pause()
                    }
                }, 200)
            }
        },
        destroy() {
            if (this.$video) {
                this.$video.pause()
            }
            if (this.$toggle) {
                this.$toggle.removeEventListener(
                    'click',
                    this.toggleVideoState,
                    false
                )
            }
            if (typeof this.motionReduceDestroy === 'function') {
                this.motionReduceDestroy()
            }
        }
    }
)

export default videoPlayPauseBehavior
